module.exports = __webpack_public_path__ + "img/zqkj.0110b0fd.jpg";